import React from "react";
import { Link, useLocation } from "react-router-dom";
import { activeNavigationKey, navigationGroups, visibleSidebarItems } from "./sidebarItems";
import { useAppSelector } from "../utils/redux/hooks";
import UseTrackNewChatAndOrder from "../hooks/UseTrackNewChatAndOrder";
import NewSidebarAlertComp from "./helpers/NewSidebarAlertComp";
import useUnreadChatCount from '../hooks/useUnreadChatCount';

export default function AdminNavigation({ onNavigate }: { onNavigate?: () => void }) {
  const accountType = useAppSelector(state => (state.user.userData as any)?.accountType);
  const telemarketingEnabled = useAppSelector(state => (state.user.userData as any)?.telemarketingEnabled === true);
  const pathname = useLocation().pathname;
  const active = activeNavigationKey(pathname);
  const items = visibleSidebarItems(accountType, telemarketingEnabled);
  const alerts = UseTrackNewChatAndOrder();
  const unreadChats = useUnreadChatCount(['admin', 'super_admin'].includes(accountType || ''));
  return <nav aria-label="Admin navigation" className="admin-navigation">
    {navigationGroups.filter(group => items.some(item => group.keys.includes(item.key))).map(group => <section key={group.label}>
      <h2>{group.label}</h2>
      {items.filter(item => group.keys.includes(item.key)).map(item => <React.Fragment key={item.key}><Link
        key={item.key} to={`/${item.key}`} onClick={onNavigate}
        aria-current={active === item.key ? "page" : undefined}>
        <img src={active === item.key ? item.activeIcon : item.icon} alt="" />
        <span>{item.label}</span>
        {item.key === 'chat' ? (unreadChats !== null && unreadChats > 0 &&
          <span aria-label={`${unreadChats} unread ${unreadChats === 1 ? 'chat' : 'chats'}`} title={`${unreadChats} unread chats`}
            style={{marginLeft:'auto',background:'#88087b',color:'#fff',borderRadius:999,padding:'2px 7px',fontSize:12,fontWeight:700,minWidth:22,textAlign:'center'}}>
            {unreadChats > 99 ? '99+' : unreadChats}
          </span>) : <NewSidebarAlertComp {...alerts} itemKey={item.key} />}
      </Link>
      </React.Fragment>)}
    </section>)}
  </nav>;
}
